module.exports = __webpack_public_path__ + "static/FoundersGroteskMonoTest-Regular-bc09f50307f6bfbbf866d35c6ffe87a1.ttf";